export default __webpack_public_path__ + "static/media/contact-us-modern-01.98b7d05d.jpg";